import React, { useState, useEffect } from "react";

import dsdesExploreApi from "apis/dsdesExplore";

import AddReferenceSources from "./AddReferenceSources";
import AssociatedReferenceSources from "./AssociatedReferenceSources";

const ReferenceSources = ({ cde, dataSource, dsde }) => {
  const [associatedReferenceSource, setAssociatedReferenceSource] = useState(
    {}
  );

  const fetchAssociatedReferenceSource = async () => {
    try {
      const { data } = await dsdesExploreApi.indexReferenceSources(dsde.id);
      setAssociatedReferenceSource(data.reference_sources[0]);
    } catch (error) {
      logger.log(error);
    }
  };

  useEffect(() => {
    fetchAssociatedReferenceSource();
  }, []);

  return (
    <>
      {!associatedReferenceSource?.id ? (
        <AddReferenceSources
          dsde={dsde}
          dataSource={dataSource}
          cde={cde}
          fetchAssociatedReferenceSource={fetchAssociatedReferenceSource}
        />
      ) : (
        <AssociatedReferenceSources
          dsde={dsde}
          fetchAssociatedReferenceSource={fetchAssociatedReferenceSource}
          associatedReferenceSource={associatedReferenceSource}
        />
      )}
    </>
  );
};
export default ReferenceSources;
